import type {
    GetAllBoardMembersResponseType
} from "./type";
import {
    request
} from "../request";

const getAllBoardMembers = async (): Promise<GetAllBoardMembersResponseType> => {
    return await request<GetAllBoardMembersResponseType>("/content/getAllBoardMembers", {
        method: "GET"
    });
};
export default getAllBoardMembers;
